import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const playlistApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
playlistApiInstance.interceptors.request.use(requestInterceptor);

export default playlistApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/playlistApi.js